import Http from './http';

export default {
  index(filter) {
    return Http.get(`/employees`, {params: {
      ...filter
    }})
  },

  getNewUsers() {
    return Http.get(`/employees/new_users`)
  }
}